(function() {
  var ROOT_SELECTOR = '.vsk-description';
  var ENHANCED_ATTR = 'data-amour-vdk-ready';
  var PANEL_CLASS = 'amour-vdk-panel';
  var IFRAME_SRC_ATTR = 'data-amour-vdk-src';

  function normalizeVariantKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '');
  }

  function getOptionValueFromInput(input) {
    if (!input) return '';
    if (input.value) return input.value;

    var labeledBy = input.labels && input.labels.length ? input.labels[0] : null;
    if (labeledBy) return labeledBy.textContent || '';

    return input.getAttribute('aria-label') || '';
  }

  function getOptionValueFromSelect(select) {
    if (!select) return '';
    if (select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
      return select.options[select.selectedIndex].text || select.value || '';
    }
    return select.value || '';
  }

  function getSelectedVariantKeys(container) {
    var scope = container.closest('main') || document;
    var keys = {};

    scope.querySelectorAll('input[type="radio"]:checked').forEach(function(input) {
      var key = normalizeVariantKey(getOptionValueFromInput(input));
      if (key) keys[key] = true;
    });

    scope.querySelectorAll('select').forEach(function(select) {
      if (select.multiple || select.disabled) return;
      if (select.name === 'quantity') return;

      var key = normalizeVariantKey(getOptionValueFromSelect(select));
      if (key) keys[key] = true;
    });

    return Object.keys(keys);
  }

  function createPanel(titleText) {
    return {
      title: titleText,
      groups: []
    };
  }

  function createGroup(markerText) {
    var rawMarker = markerText || '';
    return {
      marker: rawMarker,
      keys: rawMarker
        .split(/[|,]/)
        .map(function(item) {
          return normalizeVariantKey(item);
        })
        .filter(Boolean),
      nodes: []
    };
  }

  function parsePanels(container) {
    var nodes = Array.from(container.childNodes);
    var panels = [];
    var preface = [];
    var currentPanel = null;
    var currentGroup = null;

    function ensureDefaultGroup() {
      if (!currentPanel) return null;
      if (!currentGroup) {
        currentGroup = createGroup('');
        currentPanel.groups.push(currentGroup);
      }
      return currentGroup;
    }

    nodes.forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H6') {
        var headingText = node.textContent.trim();
        if (!headingText) return;

        if (headingText.charAt(0) === '#') {
          if (!currentPanel) {
            currentPanel = createPanel('Details');
            panels.push(currentPanel);
          }
          currentGroup = createGroup(headingText.slice(1));
          currentPanel.groups.push(currentGroup);
          return;
        }

        currentPanel = createPanel(headingText);
        panels.push(currentPanel);
        currentGroup = null;
        return;
      }

      if (!currentPanel) {
        preface.push(node);
        return;
      }

      ensureDefaultGroup().nodes.push(node);
    });

    return {
      panels: panels.filter(function(panel) {
        return panel.groups.some(function(group) {
          return group.nodes.length > 0;
        });
      }),
      preface: preface
    };
  }

  function prepareEmbeddedMedia(section) {
    section.querySelectorAll('iframe').forEach(function(iframe) {
      if (!iframe.getAttribute('loading')) {
        iframe.setAttribute('loading', 'lazy');
      }
    });
  }

  function suspendEmbeddedMedia(section) {
    section.querySelectorAll('iframe').forEach(function(iframe) {
      var src = iframe.getAttribute('src');
      if (src && !iframe.getAttribute(IFRAME_SRC_ATTR)) {
        iframe.setAttribute(IFRAME_SRC_ATTR, src);
      }
      if (src) {
        iframe.removeAttribute('src');
      }
    });
  }

  function restoreEmbeddedMedia(section) {
    section.querySelectorAll('iframe').forEach(function(iframe) {
      var src = iframe.getAttribute(IFRAME_SRC_ATTR);
      if (src && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', src);
      }
    });
  }

  function syncSectionMedia(section) {
    var body = section.closest('.amour-vdk-body');
    var shouldLoad = !section.hidden && body && !body.hidden;

    if (shouldLoad) {
      restoreEmbeddedMedia(section);
    } else {
      suspendEmbeddedMedia(section);
    }
  }

  function buildAccordion(container, parsed) {
    var fragment = document.createDocumentFragment();

    parsed.preface.forEach(function(node) {
      fragment.appendChild(node);
    });

    var accordion = document.createElement('ul');
    accordion.className = 'amour-vdk-accordion starapps-accordion';

    parsed.panels.forEach(function(panel) {
      var item = document.createElement('li');
      item.className = PANEL_CLASS + ' starapps-panel';

      var trigger = document.createElement('button');
      trigger.className = 'amour-vdk-title starapps-title';
      trigger.type = 'button';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML =
        '<span class="amour-vdk-title-text"></span><span class="amour-vdk-icon" aria-hidden="true"><span class="amour-vdk-icon-bar amour-vdk-icon-bar-horizontal"></span><span class="amour-vdk-icon-bar amour-vdk-icon-bar-vertical"></span></span>';
      trigger.querySelector('.amour-vdk-title-text').textContent = panel.title;

      var body = document.createElement('section');
      body.className = 'amour-vdk-body starapps-body';
      body.hidden = true;

      panel.groups.forEach(function(group) {
        var section = document.createElement('section');
        section.className = 'amour-vdk-variant starapps-variant';
        section.setAttribute('data-amour-vdk-marker', group.marker);
        if (group.keys.length) {
          section.setAttribute('data-amour-vdk-keys', group.keys.join(','));
        }

        group.nodes.forEach(function(node) {
          section.appendChild(node);
        });

        prepareEmbeddedMedia(section);
        body.appendChild(section);
      });

      item.appendChild(trigger);
      item.appendChild(body);
      accordion.appendChild(item);
    });

    container.textContent = '';
    fragment.appendChild(accordion);
    container.appendChild(fragment);
  }

  function updatePanelVisibility(container) {
    var activeKeys = getSelectedVariantKeys(container);

    container.querySelectorAll('.' + PANEL_CLASS).forEach(function(panel) {
      var visibleCount = 0;

      panel.querySelectorAll('.amour-vdk-variant').forEach(function(section) {
        var keyList = (section.getAttribute('data-amour-vdk-keys') || '')
          .split(',')
          .map(function(item) {
            return item.trim();
          })
          .filter(Boolean);

        var isVisible =
          keyList.length === 0 ||
          keyList.some(function(key) {
            return activeKeys.indexOf(key) !== -1;
          });

        section.hidden = !isVisible;
        syncSectionMedia(section);
        if (isVisible) visibleCount += 1;
      });

      panel.hidden = visibleCount === 0;
      panel.querySelectorAll('.amour-vdk-variant').forEach(syncSectionMedia);
    });
  }

  function bindAccordionToggles(container) {
    container.querySelectorAll('.amour-vdk-title').forEach(function(trigger) {
      if (trigger.getAttribute('data-amour-vdk-bound') === 'true') return;

      trigger.setAttribute('data-amour-vdk-bound', 'true');
      trigger.addEventListener('click', function() {
        var panel = trigger.closest('.' + PANEL_CLASS);
        var body = panel ? panel.querySelector('.amour-vdk-body') : null;
        var isExpanded = trigger.getAttribute('aria-expanded') !== 'false';

        if (!body) return;

        body.hidden = isExpanded;
        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.querySelectorAll('.amour-vdk-variant').forEach(syncSectionMedia);
      });
    });
  }

  function enhanceContainer(container) {
    if (!container || container.getAttribute(ENHANCED_ATTR) === 'true') return;

    if (container.querySelector('.starapps-panel')) {
      container.setAttribute(ENHANCED_ATTR, 'external');
      return;
    }

    var parsed = parsePanels(container);
    if (!parsed.panels.length) return;

    buildAccordion(container, parsed);
    bindAccordionToggles(container);
    updatePanelVisibility(container);
    container.setAttribute(ENHANCED_ATTR, 'true');
  }

  function enhanceAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function(container) {
      enhanceContainer(container);
      if (container.getAttribute(ENHANCED_ATTR) === 'true') {
        updatePanelVisibility(container);
      }
    });
  }

  var scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(function() {
      scheduled = false;
      enhanceAll();
    });
  }

  document.addEventListener('DOMContentLoaded', enhanceAll);
  document.addEventListener('change', scheduleRefresh, true);
  document.addEventListener('amour:variant:change', scheduleRefresh);
})();
